module.exports = __webpack_public_path__ + "static/media/factory.348c7898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/factory.svg
// module id = 275
// module chunks = 0